import { render, staticRenderFns } from "./HeaderUserPanel.vue?vue&type=template&id=631a58a0&scoped=true"
import script from "./HeaderUserPanel.vue?vue&type=script&lang=ts"
export * from "./HeaderUserPanel.vue?vue&type=script&lang=ts"
import style0 from "./HeaderUserPanel.vue?vue&type=style&index=0&id=631a58a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a58a0",
  null
  
)

export default component.exports